/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ExternalAcademicUserPasswordResetDTO
 */
export interface ExternalAcademicUserPasswordResetDTO {
	/**
	 *
	 * @type {string}
	 * @memberof ExternalAcademicUserPasswordResetDTO
	 */
	email?: string | null;
}

export function ExternalAcademicUserPasswordResetDTOFromJSON(
	json: any
): ExternalAcademicUserPasswordResetDTO {
	return ExternalAcademicUserPasswordResetDTOFromJSONTyped(json, false);
}

export function ExternalAcademicUserPasswordResetDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ExternalAcademicUserPasswordResetDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		email: !exists(json, "email") ? undefined : json["email"],
	};
}

export function ExternalAcademicUserPasswordResetDTOToJSON(
	value?: ExternalAcademicUserPasswordResetDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		email: value.email,
	};
}
